import {
  AccountBalance,
  Apartment,
  AutoAwesome,
  Business,
  Campaign,
  Diamond,
  Email,
  Groups,
  Hotel,
  Image,
  People,
  ReceiptLong,
  Science,
  Search,
  Settings,
  ShoppingCart,
  Store,
  SupportAgent,
  TravelExplore,
  Work,
} from '@mui/icons-material';

import {
  ROLE_ADMIN_USER,
  ROLE_CRUISE_COORDINATOR,
  ROLE_EMPLOYEE_USER,
  ROLE_EXPERIENCES_COORDINATOR,
  ROLE_HERO_PLANNER_ADMIN,
  ROLE_HERO_PLANNER_VIEWER,
  ROLE_HOTEL_COORDINATOR,
  ROLE_ICS_STORE_TEAM,
  ROLE_LERE_ADMIN,
  ROLE_LERE_USER,
  ROLE_LUX_LOYALTY_ADMIN,
  ROLE_TOUR_COORDINATOR,
} from './roles';
import tenants from './tenant';

export const NAVIGATION_LINK_IDS = {
  ACCOMMODATION: 'accommodation',
  AGENCIES: 'agencies',
  ASK_RICHARD: 'ask-richard',
  BANNER_UPLOAD: 'banner-upload',
  BUSINESS: 'business',
  COMMERCIAL_OPS: 'commercial-ops',
  CURATION: 'curation',
  EMAIL: 'email',
  FINANCE: 'finance',
  HERO_PLANNER: 'hero-planner',
  INVOICE_TOOLS: 'invoice-tools',
  LAB: 'lab',
  LERE: 'lere',
  MARKETING: 'marketing',
  PURCHASES: 'purchases',
  SEARCH: 'search',
  SOCIETE: 'societe',
  SUPPORT_ASSISTANT: 'support-assistant',
  SYSTEM: 'system',
  USERS: 'users',
  VENDORS: 'vendors',
} as const;

export const NAVIGATION_LINKS: Array<App.NavigationLink> = [
  {
    id: NAVIGATION_LINK_IDS.PURCHASES,
    href: '/purchases',
    label: 'Purchases',
    icon: ShoppingCart,
    requiredRoles: new Set([
      ROLE_ADMIN_USER,
      ROLE_EMPLOYEE_USER,
      ROLE_TOUR_COORDINATOR,
      ROLE_EXPERIENCES_COORDINATOR,
      ROLE_ICS_STORE_TEAM,
      ROLE_CRUISE_COORDINATOR,
    ]),
  },
  {
    id: NAVIGATION_LINK_IDS.USERS,
    href: '/',
    label: 'Users',
    icon: People,
    requiredRoles: new Set([
      ROLE_ADMIN_USER,
      ROLE_EMPLOYEE_USER,
      ROLE_TOUR_COORDINATOR,
      ROLE_EXPERIENCES_COORDINATOR,
      ROLE_ICS_STORE_TEAM,
      ROLE_CRUISE_COORDINATOR,
    ]),
  },
  {
    id: NAVIGATION_LINK_IDS.AGENCIES,
    href: '/agencies/agencies',
    label: 'Agencies',
    icon: Apartment,
    requiredRoles: new Set([
      ROLE_ADMIN_USER,
      ROLE_EMPLOYEE_USER,
      ROLE_EXPERIENCES_COORDINATOR,
      ROLE_ICS_STORE_TEAM,
      ROLE_TOUR_COORDINATOR,
    ]),
    tenants: new Set([tenants.leagenthub.value, tenants.leagenthub_cvfr.value]),
  },
  {
    id: NAVIGATION_LINK_IDS.BUSINESS,
    href: '/lebusiness',
    label: 'Business',
    icon: Business,
    requiredRoles: new Set([ROLE_EMPLOYEE_USER, ROLE_ADMIN_USER]),
  },
  {
    id: NAVIGATION_LINK_IDS.VENDORS,
    href: '/vendors',
    label: 'Vendors',
    icon: Store,
    requiredRoles: new Set([ROLE_ADMIN_USER, ROLE_EMPLOYEE_USER, ROLE_HOTEL_COORDINATOR]),
  },
  {
    id: NAVIGATION_LINK_IDS.ACCOMMODATION,
    href: '/accommodation/properties',
    label: 'Accommodation',
    icon: Hotel,
    requiredRoles: new Set([ROLE_ADMIN_USER, ROLE_EMPLOYEE_USER, ROLE_HOTEL_COORDINATOR]),
  },
  {
    id: NAVIGATION_LINK_IDS.MARKETING,
    href: '/marketing',
    label: 'Marketing',
    icon: Campaign,
    requiredRoles: new Set([ROLE_ADMIN_USER, ROLE_EMPLOYEE_USER]),
  },
  {
    id: NAVIGATION_LINK_IDS.HERO_PLANNER,
    href: '/customer-communication/hero-planner/schedules',
    label: 'Hero Planner',
    icon: AutoAwesome,
    requiredRoles: new Set([ROLE_HERO_PLANNER_VIEWER, ROLE_HERO_PLANNER_ADMIN]),
  },
  {
    id: NAVIGATION_LINK_IDS.BANNER_UPLOAD,
    href: '/customer-communication/banner-upload',
    label: 'Banner Upload',
    icon: Image,
    requiredRoles: new Set([ROLE_HERO_PLANNER_ADMIN]),
  },
  {
    id: NAVIGATION_LINK_IDS.EMAIL,
    href: '/email',
    label: 'Email',
    icon: Email,
    requiredRoles: new Set([ROLE_ADMIN_USER, ROLE_EMPLOYEE_USER]),
  },
  {
    id: NAVIGATION_LINK_IDS.CURATION,
    href: '/curation',
    label: 'Curation',
    icon: TravelExplore,
    requiredRoles: new Set([ROLE_ADMIN_USER, ROLE_EMPLOYEE_USER]),
  },
  {
    id: NAVIGATION_LINK_IDS.SEARCH,
    href: '/search',
    label: 'Search',
    icon: Search,
    requiredRoles: new Set([ROLE_ADMIN_USER, ROLE_EMPLOYEE_USER]),
  },
  {
    id: NAVIGATION_LINK_IDS.FINANCE,
    href: '/finance',
    label: 'Finance',
    icon: AccountBalance,
    requiredRoles: new Set([ROLE_ADMIN_USER, ROLE_EMPLOYEE_USER]),
  },
  {
    id: NAVIGATION_LINK_IDS.LAB,
    href: '/lab',
    label: 'Lab',
    icon: Science,
    requiredRoles: new Set([ROLE_ADMIN_USER]),
  },
  {
    id: NAVIGATION_LINK_IDS.COMMERCIAL_OPS,
    href: '/commercial-ops',
    label: 'Commercial Ops',
    icon: Work,
    requiredRoles: new Set([ROLE_EMPLOYEE_USER, ROLE_HOTEL_COORDINATOR]),
  },
  {
    id: NAVIGATION_LINK_IDS.SOCIETE,
    href: '/loyalty',
    label: 'Loyalty',
    icon: Diamond,
    requiredRoles: new Set([ROLE_ADMIN_USER, ROLE_LUX_LOYALTY_ADMIN]),
  },
  {
    id: NAVIGATION_LINK_IDS.LERE,
    href: '/lere',
    label: 'LERE',
    icon: Groups,
    requiredRoles: new Set([ROLE_LERE_ADMIN, ROLE_LERE_USER]),
  },
  {
    id: NAVIGATION_LINK_IDS.SUPPORT_ASSISTANT,
    href: '/support-assistant/chats-history',
    label: 'Support Assistant',
    icon: SupportAgent,
    requiredRoles: new Set([ROLE_ADMIN_USER]),
  },
  {
    id: NAVIGATION_LINK_IDS.SYSTEM,
    href: '/system',
    label: 'System',
    icon: Settings,
    requiredRoles: new Set([ROLE_ADMIN_USER]),
  },
  {
    id: NAVIGATION_LINK_IDS.INVOICE_TOOLS,
    href: '/invoice-tools',
    label: 'Invoice Tools',
    icon: ReceiptLong,
    requiredRoles: new Set([ROLE_EMPLOYEE_USER, ROLE_ADMIN_USER]),
  },
  {
    id: NAVIGATION_LINK_IDS.ASK_RICHARD,
    href: '/ask-richard',
    label: 'askRichard',
    icon: AutoAwesome,
    requiredRoles: new Set([ROLE_EMPLOYEE_USER, ROLE_ADMIN_USER]),
  },
];
